import {
  IonButton,
  IonCol,
  IonGrid,
  IonImg,
  IonLabel,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonToggle
} from "@ionic/react";
import { ILocationDetails } from "../../../schemas/manage/manage.Schema";
import React, { useEffect, useState } from "react";
import {
  Anywhere,
  PickUpdate,
  Trailer,
  Origin,
  Destination,
  CityError,
  PAGE_TITLES,
  None,
  StateSelectionError
} from "../../../utils/constants";
import { SelectComponent } from "../../../components/shared/SelectComponent";
import {
  getCountryCode,
  keyboardhideHandler,
  keyboardshowHandler,
  setDetails,
  stateItems
} from "../../../pages/Manage/ManageCapacity/ManagaCapacityUtil";

import "./AddManageCapacity.scss";
import PickupLocation from "../../../web/components/manage-capacity/PickupLocation";
import DestinationLocation from "../../../web/components/manage-capacity/DestinationLocation";
import PickupTime from "../../../web/components/manage-capacity/PickupTime";
import PickupDays from "../../../web/components/manage-capacity/PickupDays";
import { ManageCapacityHeader } from "../../../web/components/manage-capacity/ManageCapacityHeader";
import i18n from "i18n";
import { NewDropDown } from "../../components/common/DropDown";
import { useSelector } from "react-redux";
import {
  PreferenceCapacityTypeSetup,
  PreferenceCapacityValueChange
} from "../Preferences/PreferencesUtil";
import { Preferences_CapacityTypePopUp } from "../Preferences/Preferences_CapacityTypeModal";
import { dayjs } from "../../../utils/Date/DateUtil";

const capacityOptions = [
  { name: "Truck", desc: "Spot capacity currently available." },
  { name: "Lane", desc: "Frequently desired origin to destination." }
];

const currentDate = new Date();
let date = new Date();
date.setDate(date.getDate() + 1);

const location: ILocationDetails = {
  city: Anywhere,
  state: null,
  country: null,
  postal: null,
  lat: null,
  lng: null,
  address: null
};

const AddManageCapacity = (props: any) => {
  const { userDetails, selectedCapacity = null } = props;
  const [capacityType, setCapacityType] = useState(capacityOptions[0]);
  const [trailerType, setTrailerType] = useState("");
  const [trailerTypeResponse, setTrailerTypeResponse] = useState("");
  const [originDetails, setOriginDetails] = useState({} as ILocationDetails);
  const [showOrigin, setShowOrigin] = useState(false);
  const [originRadius, setOriginRadius] = useState(100);
  const [pickUpLocalTime, setPickUpLocalTime] = useState(
    dayjs(currentDate).format()
  );
  const [pickupFromDate, setPickupFromDate] = useState(
    dayjs(currentDate).format()
  );
  const [pickupToDate, setPickupToDate] = useState(dayjs(date).format());
  const [preferredDays, setPreferredDays] = useState([]);
  const [showDelivaryfields, setShowDelivaryfields] = useState(false);
  const [destinationDetails, setDestinationDetails] = useState({
    ...location,
    city: Anywhere,
    address: Anywhere
  } as ILocationDetails);
  const [destinationRadius, setDestinationRadius] = useState(100);
  const [isStatesShow, setStatesShow] = useState(false);
  const [originError, setOriginError] = useState<any>(false);
  const [destinationError, setDestinationError] = useState<any>(false);
  const [stateError, setStatesError] = useState(false);
  const [pickupTimeError, setPickuptimeError] = useState(false);
  const [pickupDaysError, setPickupDaysError] = useState(false);
  const [isOriginEdit, setOriginEdit] = useState(false);
  const [isDestinationEdit, setDestinationEdit] = useState(false);

  const [country, setCountry] = useState("USA");
  const [statesList, setStatesList] = useState(stateItems);
  const [statesOptions, setStatesOptions] = useState<any[]>([]);

  let dateUpdated = false;
  const [
    isOpenPreferenceCapacityTypePopup,
    setIsOpenPreferenceCapacityTypePopup
  ] = useState<boolean>(false);
  const storeData = useSelector(
    (state: any) => state && state.global && state.global.userPreferences
  );
  useEffect(() => {
    if (storeData && !props.isEditPage) {
      const changedCapacityType = PreferenceCapacityTypeSetup(storeData);
      const updatedTrailerType = PreferenceCapacityValueChange(
        changedCapacityType && changedCapacityType.value
      );
      setTrailerType(updatedTrailerType);
      setTrailerTypeResponse(updatedTrailerType);
      if (
        changedCapacityType &&
        changedCapacityType.userPreferenceExists === "No"
      ) {
        setIsOpenPreferenceCapacityTypePopup(true);
      }
    }
  }, []);
  useEffect(() => {
    if (props.countryStateCodes && props.countryStateCodes.length === 0) {
      props.getCountryStateCodes();
    }
  }, []);

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    switch (name) {
      case Trailer:
        setTrailerType(value);
        break;
      case "fromDate":
        setPickupFromDate((value && dayjs(value).format()) || "");
        break;
      case "toDate":
        setPickupToDate((value && dayjs(value).format()) || "");
        break;
      case Origin:
        value && setOriginError(false);
        (isOriginEdit || !selectedCapacity) &&
          setDetails(event.target, setOriginDetails);
        break;
      case "originRadius":
        setOriginRadius(value);
        break;
      case Destination:
        value && setDestinationError(false);
        isDestinationEdit && setDetails(event.target, setDestinationDetails);
        break;
      case "destinationRadius":
        setDestinationRadius(value);
        break;
      case "stateToggle":
        setStatesShow(!isStatesShow);
        break;
    }
  };

  const setSelectedData = () => {
    const statesList = stateItems.map((state: any, index: number) => {
      return {
        ...state,
        value: selectedCapacity.destinationStates[index] || ""
      };
    });
    setOriginEdit(false);
    setCapacityType(
      capacityOptions[
        (`${selectedCapacity.capacityType}` || "").toUpperCase() === "TRUCK"
          ? 0
          : 1
      ]
    );
    setTrailerType(selectedCapacity.trailerType);
    setOriginDetails({
      ...selectedCapacity.origin,
      lat: selectedCapacity.origin.latitude,
      lng: selectedCapacity.origin.longitude,
      address:
        selectedCapacity.origin.city +
        (selectedCapacity.origin.state
          ? `, ${selectedCapacity.origin.state}`
          : "")
    } as ILocationDetails);
    setOriginRadius(selectedCapacity.origin.radius);
    if (
      selectedCapacity.pickUpFromDate &&
      selectedCapacity.pickUpFromDate !== ""
    ) {
      setPickUpLocalTime(selectedCapacity.pickUpFromDate);
    }
    if (
      selectedCapacity.pickUpFromDate &&
      selectedCapacity.pickUpFromDate !== ""
    ) {
      setPickupFromDate(selectedCapacity.pickUpFromDate);
    }
    if (selectedCapacity.pickUpToDate && selectedCapacity.pickUpToDate !== "") {
      setPickupToDate(selectedCapacity.pickUpToDate);
    }
    setPreferredDays(selectedCapacity.preferredDays);
    setDestinationDetails({
      ...selectedCapacity.destination,
      lat: selectedCapacity.destination.latitude,
      lng: selectedCapacity.destination.longitude,
      city:
        selectedCapacity.destination.city !== null
          ? selectedCapacity.destination.city
          : capacityType.name === "Truck"
          ? Anywhere
          : null,
      address:
        selectedCapacity.destination.city !== null
          ? selectedCapacity.destination.city +
            (selectedCapacity.destination.state
              ? `, ${selectedCapacity.destination.state}`
              : "")
          : Anywhere
    } as ILocationDetails);
    setDestinationRadius(selectedCapacity.destination.radius || 100);
    setStatesShow(
      selectedCapacity && selectedCapacity.destinationStates.length > 0
    );
    setStatesList(statesList);
    setCountry(
      getCountryCode(
        selectedCapacity.destinationCountry === null
          ? "US"
          : selectedCapacity.destinationCountry
      )
    );
    setStatesOptions(
      getStateOptions(
        getCountryCode(
          selectedCapacity.destinationCountry === null
            ? "US"
            : selectedCapacity.destinationCountry
        )
      )
    );
    setShowDelivaryfields(false);
    setDestinationEdit(false);
    setPickupDaysError(false);
    setPickuptimeError(false);
  };

  useEffect(() => {
    if (selectedCapacity) {
      setSelectedData();
    } else {
      setStatesOptions(getStateOptions(country));
    }
  }, [selectedCapacity]);

  useEffect(() => {
    if (!selectedCapacity) setStatesOptions(getStateOptions(country));
  }, [props.countryStateCodes, selectedCapacity]);

  const setErrorValue = (value: boolean, name: string) =>
    name === Origin ? setOriginError(value) : setDestinationError(value);

  const updateLocalCurrentTime = (feildName: string, localTime: string) => {
    if (feildName === PickUpdate) {
      if (!dateUpdated && localTime) {
        setPickupFromDate(pickUpLocalTime);
        dateUpdated = true;
      }
      setPickUpLocalTime(localTime);
    }
  };
  const getStateOptions = (code: any) => {
    if (props.countryStateCodes.length > 0 && code) {
      const filteredCountryStates: any =
        props.countryStateCodes.length > 0 &&
        props.countryStateCodes.filter((country: any) => {
          return country.code === code;
        });
      let states = [
        ...((filteredCountryStates[0] && filteredCountryStates[0].states) || [])
      ];
      states.unshift({ code: "None", name: "None" });
      return states;
    }
    return [];
  };
  const handleCountryChange = ({ name, value }: any) => {
    let sList = statesList;
    if (country !== value.code) {
      sList = stateItems;
    }
    setStatesList(sList);
    setCountry(value.code);
    setStatesOptions(getStateOptions(value.code));
  };

  const handleStateChange = ({ name, value }: any) => {
    const list = statesList.map((state: any) => ({
      ...state,
      value: state.name === name ? value.code : state.value
    }));
    const destinationStates = list
      .filter(
        ({ value: stateValue }) => stateValue !== "" && stateValue !== None
      )
      .map((state: any) => state.value);
    setStatesError(destinationStates.length === 0);
    setStatesList(list);
  };

  const clearFields = () => {
    setCapacityType(capacityOptions[0]);
    {
      props.isEditPage
        ? setTrailerType(selectedCapacity.trailerType)
        : setTrailerType(trailerTypeResponse);
    }
    setOriginDetails({} as ILocationDetails);
    setOriginRadius(100);

    setPickUpLocalTime(dayjs(currentDate).format());
    setPickupFromDate(dayjs(currentDate).format());
    setPickupToDate(dayjs(date).format());

    setPreferredDays([]);
    setShowDelivaryfields(false);
    setDestinationDetails({
      ...location,
      city: Anywhere,
      address: Anywhere
    } as ILocationDetails);
    setDestinationRadius(100);
    setStatesShow(false);
    setOriginError(false);
    setStatesList(stateItems);
    setShowOrigin(false);
  };

  const handleSubmit = () => {
    if (
      !(
        originDetails &&
        originDetails.city &&
        originDetails.lat &&
        originDetails.lng
      )
    ) {
      setOriginError(CityError);
      return true;
    }

    if (pickupTimeError && capacityType.name === "Truck") {
      return true;
    }

    if (capacityType.name === "Lane" && preferredDays.length === 0) {
      setPickupDaysError(true);
      return true;
    }
    if (
      capacityType.name === "Truck" &&
      !(
        destinationDetails &&
        (destinationDetails.city === Anywhere ||
          (destinationDetails.city &&
            destinationDetails.lat &&
            destinationDetails.lng))
      ) &&
      !isStatesShow
    ) {
      setDestinationError(CityError);
      return true;
    }

    if (
      capacityType.name === "Lane" &&
      !(
        destinationDetails &&
        destinationDetails.city &&
        destinationDetails.city !== Anywhere &&
        destinationDetails.lat &&
        destinationDetails.lng
      ) &&
      !isStatesShow
    ) {
      setDestinationError(CityError);
      setShowDelivaryfields(true);
      setStatesError(true);
      return true;
    }

    const destinationStates = statesList
      .filter(
        ({ value: stateValue }) => stateValue !== "" && stateValue !== None
      )
      .map((state: any) => state.value);

    if (isStatesShow && destinationStates.length === 0) {
      setStatesError(true);
      return true;
    }

    setOriginEdit(false);
    setDestinationEdit(false);

    const destination =
      !isStatesShow && destinationDetails.city !== Anywhere
        ? {
            destinationCity: destinationDetails.city,
            destinationState: destinationDetails.state,
            destinationCountry: getCountryCode(destinationDetails.country),
            destinationPostalCode: destinationDetails.postal,
            destinationLatitude: destinationDetails.lat,
            destinationLongitude: destinationDetails.lng
          }
        : {
            destinationCity: null,
            destinationState: null,
            destinationCountry: null,
            destinationPostalCode: null,
            destinationLatitude: null,
            destinationLongitude: null
          };

    const localTimeZone = pickUpLocalTime && pickUpLocalTime.split("T")[1];
    const s_pickupToDate =
      pickupToDate && pickupToDate.split("T")[0] + "T" + localTimeZone;
    const s_pickupFromDate =
      pickupFromDate && pickupFromDate.split("T")[0] + "T" + localTimeZone;
    const payload = {
      capacityId: (selectedCapacity && selectedCapacity.capacityId) || null,
      userId: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn,
      upn: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member &&userDetails.memberDetailsResponse.member.upn,
      userEmail:userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.email,
      userPhone: userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.mobileNumber || userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member &&  userDetails.memberDetailsResponse.member.phoneNumberDetails && userDetails.memberDetailsResponse.member.phoneNumberDetails.number,
      capacityType: capacityType.name.toUpperCase(),
      commonCarrierId:userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      trailerType,
      originCity: originDetails.city,
      originState: originDetails.state,
      originRadius,
      originCountry: getCountryCode(originDetails.country),
      originPostalCode: originDetails.postal,
      originLongitude: originDetails.lng,
      originLatitude: originDetails.lat,
      ...destination,
      destinationRadius:
        destination.destinationCity !== null ? destinationRadius : null,
      preferredDays: capacityType.name === "Lane" ? preferredDays : [],
      pickUpToDate: capacityType.name !== "Lane" ? s_pickupToDate : null,
      pickUpFromDate: capacityType.name !== "Lane" ? s_pickupFromDate : null,
      destinationCountry: isStatesShow
        ? country
        : getCountryCode(destinationDetails.country),
      destinationStates: isStatesShow ? destinationStates : []
    };

    props.handleSubmit(payload, clearFields);
  };

  const capacityId: string =
    (selectedCapacity && selectedCapacity.capacityId) || "";

  const handleCheck = (e: any) => {
    const {
      currentTarget: { checked }
    } = e;
    setDestinationDetails({
      ...location,
      city: checked ? Anywhere : "",
      address: checked ? Anywhere : ""
    });
  };
  const closeShowModal = (newCapacityTypeSelected : string) => {
   setIsOpenPreferenceCapacityTypePopup(false)
   setTrailerType(newCapacityTypeSelected)
   };

  return (
    <>
      <Preferences_CapacityTypePopUp
        isOpen={isOpenPreferenceCapacityTypePopup}
        closeModal={(value : string) => closeShowModal(value)}
      />
      <IonPage className="add-manage-capacity-page">
        {(props.isEditPage && (
          <ManageCapacityHeader
            title={capacityId}
            breadcrumbItems={[
              { name: "Manage Capacity", backUrl: "/app/manage-capacity" },
              {
                name: "View",
                backUrl: `/app/manage-capacity/view/${capacityId}`
              },
              { name: "Edit", backUrl: "#" }
            ]}
          />
        )) || (
          <ManageCapacityHeader
            title={PAGE_TITLES.MANAGE_CAPACITY_ADD}
            breadcrumbItems={[
              { name: "Manage Capacity", backUrl: "/app/manage-capacity" },
              { name: "Add New Capacity", backUrl: "#" }
            ]}
          />
        )}
        <IonGrid className="add-capacity-grid">
          <IonRow className="add-capacity-row">
            <IonCol className="add-capacity-col" size="12">
              <h3 className="field-required-title">*All fields are required</h3>
            </IonCol>
          </IonRow>
          <IonRow className="add-capacity-row">
            <IonCol className="add-capacity-col" size="4" size-lg="2.5">
              <IonLabel class="capacity-label">Capacity Type</IonLabel>
            </IonCol>
            <IonCol
              className="add-capacity-col capacity-selector"
              size="7.25"
              size-lg="4.6"
            >
              <NewDropDown
                labelName="Select Mode"
                TrailerType={trailerType}
                handleChange={(e: any) => {
                  const event = {
                    target: { name: Trailer, value: e.target.value }
                  };
                  handleChange(event);
                }}
              />
            </IonCol>

            <IonCol
              size="7.4"
              offset="3"
              offset-lg="0"
              size-lg="4.9"
              className="add-capacity-col capacity-col-3"
            >
              <div className="capacity-checkbox-field">
                <IonRadioGroup
                  className="capacity-radio-gp"
                  value={capacityType}
                  onIonChange={(event: any) => {
                    setCapacityType(event.detail.value);
                  }}
                >
                  {capacityOptions.map((capacityType: any, index: number) => (
                    <React.Fragment key={capacityType.name}>
                      <IonRadio
                        className="capacity-radio"
                        value={capacityType}
                      />
                      <IonLabel className="capacity-radio-lbl">
                        {capacityType.name}
                      </IonLabel>
                    </React.Fragment>
                  ))}
                </IonRadioGroup>
              </div>
            </IonCol>
          </IonRow>

          <IonRow className="add-capacity-row">
            <IonCol className="add-capacity-col" size="12">
              <IonGrid className="add-capcity-location-grid add-capacity-grid-mobile">
                <IonRow className="origin-location-row">
                  <IonImg
                    className="icon origin-icon"
                    src="assets/icon/origin-pointer.svg"
                  />
                  <IonCol
                    className="origin-location-col"
                    size="3.5"
                    size-lg="2"
                  >
                    <IonLabel class="capacity-label">Origin</IonLabel>
                  </IonCol>
                  <IonCol className="origin-location-col" size="8" size-lg="5">
                    <PickupLocation
                      origin={originDetails.address || ""}
                      originCountry={originDetails.country || ""}
                      originPostalCode={originDetails.postal || ""}
                      originError={originError}
                      originRadius={originRadius}
                      handleChange={handleChange}
                      rangeDisabled={true}
                      isDestination={false}
                      defaultValue={Anywhere}
                      useHandler={false}
                      setErrorValue={setErrorValue}
                      updateLocalCurrentTime={updateLocalCurrentTime}
                      showDate={false}
                      onFocus={() => {
                        if (!isOriginEdit) {
                          setOriginEdit(true);
                        }
                      }}
                    />
                  </IonCol>
                  <IonCol
                    size="8"
                    offset="3.5"
                    size-lg="5"
                    offset-lg="0"
                    className="origin-location-col capacity-col-3"
                  >
                    {capacityType.name === "Truck" ? (
                      <PickupTime
                        pickUpLocalTime={pickUpLocalTime}
                        handleChange={handleChange}
                        fromDate={pickupFromDate}
                        toDate={pickupToDate}
                        error={pickupTimeError}
                        handleError={setPickuptimeError}
                      />
                    ) : (
                      <PickupDays
                        preferredDays={preferredDays}
                        setPickupDays={setPreferredDays}
                        showError={pickupDaysError}
                        handleError={setPickupDaysError}
                      />
                    )}
                  </IonCol>
                </IonRow>

                <IonRow className="destination-location-row">
                  <IonImg
                    className="icon dst-icon"
                    src="assets/icon/dst-pointer.svg"
                  />
                  <IonCol
                    className="destination-location-col"
                    size="3.5"
                    size-lg="2"
                  >
                    <IonLabel class="capacity-label">Destination</IonLabel>
                  </IonCol>
                  <IonCol
                    className="destination-location-col"
                    size="8"
                    size-lg="5"
                  >
                    {isStatesShow ? (
                      <div
                        data-test="state-list-wrapper"
                        className={`states-list-wrapper ${
                          stateError ? "error" : ""
                        }`}
                      >
                        <SelectComponent
                          key={`country`}
                          options={props.countryStateCodes}
                          placeholder={"Choose the country"}
                          label={""}
                          name={"country"}
                          value={country}
                          handleChange={handleCountryChange}
                        />
                        <IonLabel className="stateLable-web">
                          Select 1 - 3 States/Provinces
                        </IonLabel>
                        {statesList &&
                          statesList.map((state: any, index: number) => (
                            <SelectComponent
                              key={`state${index}`}
                              options={statesOptions}
                              placeholder="None"
                              label={""}
                              name={state.name}
                              value={
                                statesList[index] && statesList[index].value
                              }
                              handleChange={handleStateChange}
                            />
                          ))}
                        {stateError && (
                          <div className="states-not-selected-error">
                            <p>{i18n.t(StateSelectionError)}</p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <DestinationLocation
                        isLane={capacityType.name === "Lane"}
                        destination={`${
                          destinationDetails.address !== Anywhere
                            ? destinationDetails.address
                            : capacityType.name === "Truck"
                            ? Anywhere
                            : ""
                        }`}
                        destinationCountry={destinationDetails.country || ""}
                        destinationPostalCode={destinationDetails.postal || ""}
                        destinationError={destinationError}
                        Destination={"DestinationDetails"}
                        handleChange={handleChange}
                        rangeDisable={
                          destinationDetails &&
                          destinationDetails.address === Anywhere
                        }
                        handleCheck={handleCheck}
                        platform="mobile"
                        keyboardshowHandler={keyboardshowHandler}
                        keyboardhideHandler={keyboardhideHandler}
                        defaultValue={Anywhere}
                        isDestination={true}
                        useHandler={true}
                        setErrorValue={setErrorValue}
                        destinationRadius={destinationRadius}
                        updateLocalCurrentTime={updateLocalCurrentTime}
                        showDate={false}
                        onFocus={() => {
                          if (!isDestinationEdit) {
                            setDestinationEdit(true);
                          }
                        }}
                      />
                    )}
                  </IonCol>
                  <IonCol
                    size="8"
                    offset="3.5"
                    size-lg="5"
                    offset-lg="0"
                    className="destination-location-col capacity-col-3 select-states"
                  >
                    <IonToggle
                      mode="ios"
                      class="state-toggle"
                      checked={isStatesShow}
                      name="stateToggle"
                      onIonChange={handleChange}
                    ></IonToggle>
                    <IonLabel className="capacity-select-state-label">
                      Select States
                    </IonLabel>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonCol>
          </IonRow>

          <IonRow className="add-capacity-row">
            <IonCol className="add-capacity-col" size="12">
              <div className="add-capacity-actions">
                <IonButton
                  className="btn-action btn-clear"
                  data-test="capacity-submit"
                  onClick={() => {
                    clearFields();
                  }}
                >
                  <IonImg
                    className="star_icon delete-icon"
                    data-test="capacity-card-delete"
                    src="assets/icon/Delete_bin.svg"
                  />
                  {"  "}
                  Clear
                </IonButton>
                &nbsp;&nbsp;
                <IonButton
                  className="btn-action btn-save"
                  data-test="capacity-submit"
                  onClick={handleSubmit}
                >
                  <IonImg
                    className="star_icon view-icon"
                    data-test="capacity-card-delete"
                    src="assets/icon/view icon.svg"
                  />
                  {"  "}
                  Save
                </IonButton>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonPage>
    </>
  );
};

export default AddManageCapacity;
